import React from "react";

import {
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
} from "@mui/material/useAutocomplete";

import { Column, ColumnFilter } from "../../export";
import AutoSuggest from "../../components/Generic/AutoSuggest";

export interface Props {
  inputValue?: string;
  onChangeInput?: (value: string, reason: AutocompleteInputChangeReason) => void;
  placeholder?: string;
  columnsSelected?: ColumnFilter[];
  onChangeColumnsSelected?: (columns: ColumnFilter[]) => void;
  columns?: Column[];
}

const SearchSuggest = (props: Props) => {
  const {
    columns,
    inputValue,
    onChangeInput,
    placeholder,
    columnsSelected,
    onChangeColumnsSelected,
  } = props;

  return (
    <AutoSuggest
      dataCy="search"
      getOptionLabel={(column?: ColumnFilter | any) => {
        if (column && column?.title)
          return `${column?.placeholderSearch ?? column?.title}: ${column?.value || inputValue}`;

        return "";
      }}
      onChangeInput={onChangeInput}
      inputValue={inputValue}
      filterOptions={(options) => options}
      getOptionSelected={(option: ColumnFilter, value: ColumnFilter) =>
        option?.title === value?.title
      }
      placeholder={placeholder || "Search"}
      value={columnsSelected}
      onChange={(columnsFilter: ColumnFilter[], reason: AutocompleteChangeReason) => {
        columns?.forEach((column) => {
          if (column?.associationColumnSettings) {
            const { whenSearching } = column?.associationColumnSettings;
            whenSearching?.disableSorting(false);
          }
        });

        const columnsUpdated: ColumnFilter[] = [];

        if (columnsFilter && columnsFilter?.length > 0) {
          columnsFilter.forEach((column) => {
            if (reason === "removeOption" || reason === "clear") {
              columnsUpdated.push({ ...column, value: "" });
            } else if (!column?.value) {
              columnsUpdated.push({ ...column, value: inputValue });
              if (column?.associationColumnSettings) {
                const { whenSearching } = column?.associationColumnSettings;
                whenSearching?.clearSorting(undefined);
                whenSearching?.disableSorting(true);
              }
            }
          });
        }
        if (onChangeColumnsSelected) onChangeColumnsSelected(columnsUpdated);
      }}
      disabled={!!(columnsSelected && columnsSelected?.length > 0)}
      multiple
      getOptionDisabled={!inputValue ? () => true : undefined}
      options={
        columns && columns?.length > 0 ? columns.filter((column) => !column?.hideSearch) : []
      }
      limitTags={1}
    />
  );
};

export default SearchSuggest;
